import { Card, Col, Row } from "react-bootstrap";
import { IIncidentUpdateRequestDetails } from "../../../api/Incident/IIncidentUpdateRequestDetails";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { IncidentUpdateRequestIcon } from "../../../leap-components/icons/LeapIcons";

interface IncidentUpdateRequestHeaderProps {
  incidentUpdateRequestDetails: IIncidentUpdateRequestDetails;
  licenceProfile: ILicenceProfile;
}

const IncidentUpdateRequestHeader = ({
  incidentUpdateRequestDetails,
  licenceProfile,
}: IncidentUpdateRequestHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <IncidentUpdateRequestIcon />
                  </td>
                  <td>
                    <h2>Incident Update Request</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={incidentUpdateRequestDetails.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Status"}
              value={incidentUpdateRequestDetails.status}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={incidentUpdateRequestDetails.licenceDetails?.reg_no}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default IncidentUpdateRequestHeader;
